<h3>
  <label>New Leads</label>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(uploadFlag)" (click)="displayUpload()">Modify</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(new)" (click)="switchType('new')">New Leads</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(unresolved)" (click)="switchType('unresolved')">Unresolved Leads</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(dead)" (click)="switchType('dead')">Dead Leads</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(onhold)" (click)="switchType('onhold')">Leads On Hold</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button (click)="exportLeadsCSV()" id="export_button">Export as .csv</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(addFlag)" (click)="displayAdd()">Add Lead</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <span>Count: {{rowCount}}</span>
  </ng-container>
</h3>
<ng-container *ngIf="uploadFlag; else sendlabel" style="display:inline;">
  <newleads-update (open_close)="receiveUploadFlag($event)" [inUidList]="headerUIDList"></newleads-update>
</ng-container>
<ng-container *ngIf="addFlag; else sendlabel" style="display:inline;">
  <newleads-add (open_close)="receiveAddFlag($event)" ></newleads-add>
</ng-container>


<ng-template #sendlabel>
</ng-template>

<div>
  <newleads-table #child (rowCountEvent)="receiveCount($event)" (uidList)="receiveUIDList($event)"></newleads-table>
</div>
